import cartAPI from 'apis/cart';

import type { CartOrderOption } from './cart_order_options.types';

export const CartOrderOptionsModel = {
  async all() {
    const { data } = await cartAPI.get<Required<CartOrderOption[]>>('/order_options');
    return data;
  },
  async create(payload: { add: number; remove?: number }) {
    const { add, remove } = payload;
    if (remove) {
      await cartAPI.delete(`/order_options/${remove}`);
    }

    await cartAPI.post<{ id: number }>('/order_options', { option_api_id: add, quantity: 1 });
  },
  async delete(id: number) {
    await cartAPI.delete(`/order_options/${id}`);
  },
};
